import Vue from 'vue'
import Router from 'vue-router'
import { resolve } from 'url';

Vue.use(Router)
export default new Router({
  mode:'history',
  routes: [
        //pc端口开始
        {
            path:'/',
            redirect:{name:'login'},
        },
        {
            path: '/judge',
            name: 'judge',
            component:resolve => require(['@/view/user/judge'], resolve),
            
        },
        {
            path: '/login',
            name: 'login',
            component:resolve => require(['@/view/user/login'], resolve),
            
        },
        {
            path: '/user',
            name: 'user',
            component:resolve => require(['@/view/user/UserView'], resolve),
            redirect: {name:'index'},
            children: [
                {
                    path: 'index',
                    name: 'index',
                    component:resolve => require(['@/view/user/index'], resolve),
                    
                },
                {
                    path: 'message',
                    name: 'message',
                    component:resolve => require(['@/view/user/message'], resolve),
                
                },
                {
                    path: 'register',
                    name: 'register',
                    component:resolve => require(['@/view/user/register'], resolve),
                
                },
                {
                    path: 'reset',
                    name: 'reset',
                    component:resolve => require(['@/view/user/reset'], resolve),
                
                },
            ]
        },
   //pc端口结束
  ]
})
// export 



// WEBPACK FOOTER //
// ./src/router/index.js